// @flow

import React, {forwardRef} from 'react';
import classNames from 'classnames';
import {convertPxToRem} from '@pb/kit-util-convert-px-to-rem';

import type {AbstractComponent, Node} from 'react';

export const Indent = {
    NONE: 'NONE',
    S: 'S',
    M: 'M',
    L: 'L'
};

export const Align = {
    TOP: 'TOP',
    BOTTOM: 'BOTTOM',
    CENTER: 'CENTER'
};

const headerClassName = 'data-table__table-header';

const ALIGNMENT_CLASSES = {
    [Align.TOP]: `${headerClassName}_top`,
    [Align.BOTTOM]: `${headerClassName}_bottom`,
    [Align.CENTER]: ''

};

const INDENT_CLASSES = {
    [Indent.NONE]: null,
    [Indent.S]: `${headerClassName}_s`,
    [Indent.M]: `${headerClassName}_m`,
    [Indent.L]: `${headerClassName}_l`
};


type Props = {
    active?: boolean,
    children: Node,
    height?: number,
    mainColumn?: boolean,
    indent?: $Keys<typeof Indent>,
    hoverable?: boolean,
    mix?: string,
    align?: $Keys<typeof Align>,
};

export const TableHeader: AbstractComponent<Props, HTMLElement> = forwardRef<Props, HTMLElement>(
    function TableHeader(props: Props, ref: Function) {
        const {
            active = false,
            children,
            height,
            mainColumn = false,
            indent = Indent.S,
            hoverable = true,
            align = Align.CENTER,
            mix = ''
        } = props;

        const classes = classNames('data-table__table-header',
            {
                'data-table__table-header_active': active,
                'data-table__table-header_fixed': mainColumn,
                'data-table__table-header_hoverable': hoverable,
                [ALIGNMENT_CLASSES[align]]: align
            },
            mix,
            INDENT_CLASSES[indent]
        );

        return (
            <div
                ref={ref}
                className={classes}
                style={height || height === 0 ? {'--header-row-height': convertPxToRem(height) || 0} : null}>

                {children}
                <span className="data-table__hover"/>
            </div>
        );
    }
);

TableHeader.displayName = 'TableHeader';
